// ==========================================
// FUNZIONE GLOBALE WISHLIST PER PRODOTTO
// ==========================================
window.toggleProductWishlistItem = function(handle, title, price, image, btnElement) {
  let wishlist = JSON.parse(localStorage.getItem('koji_wishlist_data')) || [];
  const index = wishlist.findIndex(item => item.handle === handle);

  if (index > -1) {
    wishlist.splice(index, 1);
    btnElement.classList.remove('is-active');
  } else {
    wishlist.push({ handle, title, price, image });
    btnElement.classList.add('is-active');
    if (navigator.vibrate) navigator.vibrate(50);
  }

  localStorage.setItem('koji_wishlist_data', JSON.stringify(wishlist));

  const headerBadges = document.querySelectorAll('.koji-wishlist-badge');
  headerBadges.forEach(badge => {
    badge.textContent = wishlist.length;
    badge.classList.toggle('is-active', wishlist.length > 0);
  });
};

document.addEventListener('DOMContentLoaded', function() {
  
  // 0. INIZIALIZZA WISHLIST
  function updateWishlistHeart() {
    const wishlist = JSON.parse(localStorage.getItem('koji_wishlist_data')) || [];
    const btn = document.querySelector('.koji-btn-wishlist-main');
    if (btn) {
      const handle = btn.dataset.handle;
      if(wishlist.some(item => item.handle === handle)) {
        btn.classList.add('is-active');
      }
    }
  }
  updateWishlistHeart();

  // ==========================================
  // 📖 NOVITÀ: TOGGLE TRAMA (READ MORE)
  // ==========================================
  const storyToggleBtn = document.getElementById('koji-story-toggle');
  const storyContent = document.getElementById('koji-story-content');
  
  if (storyToggleBtn && storyContent) {
    // Nascondi il bottone se il testo è già corto di suo
    if (storyContent.scrollHeight <= storyContent.clientHeight + 10) {
      storyToggleBtn.style.display = 'none';
      storyContent.style.maxHeight = 'none';
      storyContent.style.setProperty('--after-opacity', '0'); // Pseudo elemento rimosso se corto
    }

    storyToggleBtn.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        this.setAttribute('aria-expanded', 'false');
        storyContent.classList.remove('is-expanded');
      } else {
        this.setAttribute('aria-expanded', 'true');
        storyContent.classList.add('is-expanded');
      }
    });
  }

  // 1. GALLERIA IMMAGINI
  const mainImage = document.getElementById('koji-main-product-img');
  const thumbnails = document.querySelectorAll('.koji-thumb-btn');
  if (mainImage && thumbnails.length > 0) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        if(navigator.vibrate) navigator.vibrate(10); 
        thumbnails.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        const newUrl = this.getAttribute('data-img-url');
        mainImage.style.transform = 'scale(0.95)';
        mainImage.style.opacity = 0;
        setTimeout(() => {
          mainImage.src = newUrl;
          mainImage.style.transform = 'scale(1)';
          mainImage.style.opacity = 1;
        }, 200); 
      });
    });
  }

  // 2. ACCORDIONS 
  const accordionHeaders = document.querySelectorAll('.koji-accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      if(navigator.vibrate) navigator.vibrate(10);
      const content = this.nextElementSibling;
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        this.setAttribute('aria-expanded', 'false');
        content.style.opacity = 0;
        setTimeout(() => { content.style.display = 'none'; }, 200);
      } else {
        this.setAttribute('aria-expanded', 'true');
        content.style.display = 'block';
        setTimeout(() => { content.style.opacity = 1; }, 10);
      }
    });
  });

  // 3. LOGICA POP-UP VARIANT
  const variantTrigger = document.getElementById('koji-variant-badge-trigger');
  const variantPopup = document.getElementById('koji-variant-popup');
  const popupClose = document.getElementById('koji-popup-close');
  const popupContainer = document.querySelector('.koji-variant-pop-container');

  if (variantTrigger && variantPopup && popupClose && popupContainer) {
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function openPopup() { variantPopup.classList.add('is-open'); variantTrigger.setAttribute('aria-expanded', 'true'); }
    function closePopup() { variantPopup.classList.remove('is-open'); variantTrigger.setAttribute('aria-expanded', 'false'); }

    if (isDesktop) {
      popupContainer.addEventListener('mouseenter', openPopup);
      popupContainer.addEventListener('mouseleave', closePopup);
    } else {
      variantTrigger.addEventListener('click', function(e) {
        e.stopPropagation(); 
        if (variantPopup.classList.contains('is-open')) closePopup(); else openPopup();
      });
      popupClose.addEventListener('click', function(e) { e.stopPropagation(); closePopup(); });
      document.addEventListener('click', function(e) {
        if (variantPopup.classList.contains('is-open') && !popupContainer.contains(e.target)) closePopup();
      });
    }
  }

  // 4. AGGIORNAMENTO BADGE CARRELLO HEADER
  function updateHeaderCartBadge() {
    fetch('/cart.js').then(resp => resp.json()).then(cartData => {
      const headerBadge = document.getElementById('koji-cart-badge');
      if (headerBadge) {
        headerBadge.textContent = cartData.item_count;
        if (cartData.item_count > 0) { headerBadge.classList.add('is-active'); } 
        else { headerBadge.classList.remove('is-active'); }
      }
    });
  }

  // 5. LOGICA VARIANTI (SHOPIFY)
  const variantOptions = document.querySelectorAll('.koji-option-btn');
  const hiddenSelect = document.getElementById('koji-variant-select-hidden');
  const inputId = document.getElementById('koji-variant-id');
  const priceBox = document.getElementById('koji-price-box');

  if (variantOptions.length > 0 && hiddenSelect) {
    variantOptions.forEach(btn => {
      btn.addEventListener('click', function() {
        if(navigator.vibrate) navigator.vibrate(15);
        const parentGroup = this.closest('.koji-option-values');
        parentGroup.querySelectorAll('.koji-option-btn').forEach(b => b.classList.remove('is-selected'));
        this.classList.add('is-selected');

        const allSelected = document.querySelectorAll('.koji-option-btn.is-selected');
        let selectedValues = [];
        allSelected.forEach(el => selectedValues.push(el.getAttribute('data-value')));
        
        let matchedOption = Array.from(hiddenSelect.options).find(opt => opt.text.includes(selectedValues[0])); 
        
        if (matchedOption) {
          hiddenSelect.value = matchedOption.value;
          if (inputId) inputId.value = matchedOption.value; 
          
          const newPrice = matchedOption.getAttribute('data-price');
          const newCompare = matchedOption.getAttribute('data-compare-price');
          
          if (priceBox) {
            let priceHtml = '';
            if (newCompare && newCompare !== '') {
              priceHtml += `<span class="koji-product-price-old">${newCompare}</span><span class="koji-product-price is-sale">${newPrice}</span>`;
            } else {
              priceHtml += `<span class="koji-product-price">${newPrice}</span>`;
            }
            priceBox.innerHTML = priceHtml;
            priceBox.style.transform = 'scale(1.1)';
            setTimeout(() => { priceBox.style.transform = 'scale(1)'; }, 150);
          }

          const varImg = matchedOption.getAttribute('data-img');
          if (varImg && varImg !== '' && mainImage) {
            mainImage.style.transform = 'scale(0.95)';
            mainImage.style.opacity = 0;
            setTimeout(() => { mainImage.src = varImg; mainImage.style.transform = 'scale(1)'; mainImage.style.opacity = 1; }, 200);
          }
        }
      });
    });
  }

  // 6. IL REATTORE KOJI: ADD TO CART + QTY
  const productCardWrap = document.querySelector('[data-koji-product-card]');
  if (productCardWrap) {
    const addBtn = productCardWrap.querySelector('.koji-js-add-btn-main');
    const btnText = productCardWrap.querySelector('.koji-drawer-text-main');
    const qtyControls = productCardWrap.querySelector('.koji-drawer-qty-controls-main');
    const maxQtyAttr = productCardWrap.getAttribute('data-max-qty');
    const maxQty = maxQtyAttr ? parseInt(maxQtyAttr, 10) : 9999;
    
    if (addBtn && inputId && qtyControls) {
      const qtyNumDisplay = qtyControls.querySelector('.koji-d-qty-num-main');
      const btnMinus = qtyControls.querySelector('.koji-d-qty-minus-main');
      const btnPlus = qtyControls.querySelector('.koji-d-qty-plus-main');
      let currentQtyInCart = 0; 
      const originalBtnText = btnText ? btnText.textContent : 'Aggiungi al carrello'; 
      let qtyDebounceTimer;

      const updatePlusBtnUI = () => {
        if (currentQtyInCart >= maxQty) { btnPlus.classList.add('is-disabled'); } 
        else { btnPlus.classList.remove('is-disabled'); }
      };

      const executeCartUpdate = (targetQuantity) => {
        const currentVariantId = inputId.value; 
        const isRemovingCompletely = targetQuantity === 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 'id': currentVariantId, 'quantity': targetQuantity })
        }).then(response => response.json()).then(data => {
          updateHeaderCartBadge();
          window.dispatchEvent(new Event('cart:updated'));
          if (isRemovingCompletely) {
            productCardWrap.classList.remove('is-qty-mode');
            if(btnText) btnText.textContent = originalBtnText; 
            updatePlusBtnUI();
          }
        });
      };

      const updateCartDebounced = (targetQuantity) => {
        clearTimeout(qtyDebounceTimer);
        qtyDebounceTimer = setTimeout(() => { executeCartUpdate(targetQuantity); }, 400); 
      };

      addBtn.addEventListener('click', function(e) {
        if (e.target.closest('.koji-drawer-qty-controls-main') || productCardWrap.classList.contains('is-qty-mode')) return;
        e.preventDefault(); e.stopPropagation(); 
        const currentVariantId = inputId.value;
        if (!currentVariantId) return;

        if (navigator.vibrate) navigator.vibrate([15, 30, 15]);
        this.blur(); this.classList.add('is-loading');
        currentQtyInCart = 1; updatePlusBtnUI();
        
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 'items': [{ 'id': currentVariantId, 'quantity': 1 }] })
        }).then(response => response.json()).then(data => {
          this.classList.remove('is-loading');
          productCardWrap.classList.add('is-success');
          if(btnText) btnText.textContent = 'Preso!';
          if (qtyNumDisplay) qtyNumDisplay.textContent = currentQtyInCart;
          updateHeaderCartBadge();
          window.dispatchEvent(new Event('cart:updated'));
          setTimeout(() => {
            productCardWrap.classList.remove('is-success');
            productCardWrap.classList.add('is-qty-mode');
          }, 800); 
        });
      });

      if (btnPlus && btnMinus) {
        btnPlus.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          if (currentQtyInCart >= maxQty) { if (navigator.vibrate) navigator.vibrate([30, 50, 30]); return; }
          if (navigator.vibrate) navigator.vibrate(15);
          currentQtyInCart++;
          if(qtyNumDisplay) { qtyNumDisplay.textContent = currentQtyInCart; qtyNumDisplay.style.transform = 'scale(1.3)'; setTimeout(()=> qtyNumDisplay.style.transform = 'scale(1)', 150); }
          updatePlusBtnUI(); updateCartDebounced(currentQtyInCart); 
        });

        btnMinus.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          if (navigator.vibrate) navigator.vibrate(15);
          if (currentQtyInCart > 0) {
            currentQtyInCart--;
            if (currentQtyInCart > 0) { 
              if(qtyNumDisplay) { qtyNumDisplay.textContent = currentQtyInCart; qtyNumDisplay.style.transform = 'scale(0.7)'; setTimeout(()=> qtyNumDisplay.style.transform = 'scale(1)', 150); } 
            } else { if(qtyNumDisplay) qtyNumDisplay.textContent = "0"; }
            updatePlusBtnUI(); updateCartDebounced(currentQtyInCart);
          }
        });
      }
    }
  }
});